"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const BasicWorkMetadata_1 = __importDefault(require("@Components/ViewWork/BasicWorkMetadata"));
const contexts_1 = require("@App/contexts");
const WritersSection_1 = __importDefault(require("@Components/ViewWork/WritersSection"));
const PublishersSection_1 = __importDefault(require("@Components/ViewWork/PublishersSection"));
const RecordingsSection_1 = __importDefault(require("@Components/ViewWork/RecordingsSection"));
const MatchedRecordingsSection_1 = __importDefault(require("@Components/ViewWork/MatchedRecordingsSection"));
const calculate_total_known_shares_1 = __importDefault(require("@App/helpers/work-entities/utils/calculate-total-known-shares"));
const ViewWork = (props) => {
    var _a, _b, _c;
    const { rightsholderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const currentRightsholderId = rightsholderStore.optionalCurrentRightsholderId;
    const workId = props.viewWork.id;
    return (react_1.default.createElement("div", { className: 'view-work-wrapper' },
        props.workType !== 'claim-wizard' && (react_1.default.createElement(BasicWorkMetadata_1.default, { viewWork: props.viewWork, workType: props.workType, rightsholderId: currentRightsholderId, errors: props === null || props === void 0 ? void 0 : props.workErrors, editing: props.editing })),
        react_1.default.createElement(WritersSection_1.default, { writers: props.viewWork.writers, workId: workId, rightsholderId: currentRightsholderId, editing: props.editing, workType: props.workType, writerErrors: (_a = props.workErrors) === null || _a === void 0 ? void 0 : _a.writers }),
        react_1.default.createElement(PublishersSection_1.default, { publishers: props.viewWork.originalPublishers, workId: workId, workType: props.workType, rightsholderId: currentRightsholderId, totalKnownShares: (0, calculate_total_known_shares_1.default)(props.viewWork), myShares: props.myShares, editing: props.editing, publisherErrors: (_b = props.workErrors) === null || _b === void 0 ? void 0 : _b.originalPublishers }),
        props.workType !== 'claim-wizard' && (react_1.default.createElement(react_1.default.Fragment, null, props.showMatchedRecordings ? (react_1.default.createElement(MatchedRecordingsSection_1.default, { work: props.viewWork })) : (react_1.default.createElement(RecordingsSection_1.default, { work: props.viewWork, workType: props.workType, rightsholderId: currentRightsholderId, errors: (_c = props.workErrors) === null || _c === void 0 ? void 0 : _c.recordings, editing: props.editing }))))));
};
exports.default = ViewWork;
